const s = /((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)([a-zA-Z0-9\-_])?/gi, c = /(?:youtube(?:-nocookie)?\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/, n = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g, _ = /<img\s+[^>]*src="([^"]*)"[^>]*>/g, R = /<[^/>][^>]*><\/[^>]+>/g, t = /[\\^$.*+?()[\]{}|]/g, A = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/gim, e = (o) => t.test(o) ? o.replace(t, "\\$&") : o, g = (o) => {
  const E = e(o);
  return new RegExp(`${E}|{{([^{}]*)}}`, "gi");
};
export {
  n as EMAIL_REGEX,
  R as EMPTY_TAG_REGEX,
  _ as IMAGE_TAG_REGEX,
  A as URL_REGEX,
  s as YOUTUBE_URL_REGEX,
  c as YOUTUBE_VIDEO_ID_REGEX,
  e as escapeRegExp,
  g as getCouponRegex
};
